import { FormHTMLAttributes, forwardRef } from 'react';

import styles from './modal-components.module.css';

type ModalFormProps = FormHTMLAttributes<HTMLFormElement>;

export const ModalForm = forwardRef<HTMLFormElement, ModalFormProps>(({ children, ...props }, ref) => (
  <form className={styles.form} {...props} ref={ref}>
    {children}
  </form>
));
ModalForm.displayName = 'ModalForm';
